import { useState, useEffect, useCallback, useMemo } from 'react';
import { useRoleCategoryApi } from '../../../hooks/useRoleCategoryApi';

export const useAllRolesCategoryViewModel = () => {
  const [rolesCategory, setRolesCategory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const {
    getRolesCategory,
    deleteRoleCategory,
    createRoleCategory,
    updateRoleCategory: apiUpdateRoleCategory,
    cacheOperations: { writeRolesCategories, readRolesCategories }
  } = useRoleCategoryApi();


  const fetchRolesCategory = useCallback(async () => {
    if (!loading) setLoading(true);
    try {
      const result = await getRolesCategory();
      if (result.success) {
        setRolesCategory(result.data);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [getRolesCategory]);

  // Only fetch on mount
  useEffect(() => {
    fetchRolesCategory();
  }, []); // Remove fetchRolesCategory from dependencies

  const handleDelete = useCallback(async (rolesCat) => {
    try {
      const result = await deleteRoleCategory(rolesCat.role_category_id);
      if (result.success) {
        await fetchRolesCategory();
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    }
  }, [deleteRoleCategory, fetchRolesCategory]);

  const handleCreateRoleCategory = useCallback(async (formData) => {
    try {
      console.log("53formData", formData)
      const result = await createRoleCategory(formData);
      if (result.success) {
        await fetchRolesCategory();
        return { success: true };
      }
    } catch (error) {
      // Pass through the error message
      throw new Error(error.message);
    }
  }, [createRoleCategory, fetchRolesCategory]);

  const updateRoleCategory = useCallback(async (roleCategoryId, formData) => {
    try {
      const result = await apiUpdateRoleCategory(roleCategoryId, formData);
      if (result.success) {
        const rolesCategories = readRolesCategories();
        const updatedRolesCategories = rolesCategories.map(rolescategory =>
          rolescategory.role_category_id === roleCategoryId ? result.data : rolescategory
        );
        writeRolesCategories(updatedRolesCategories);
        return { success: true };
      }
    } catch (error) {
      // Pass through the error message
      throw new Error(error.message);
    }
  }, [apiUpdateRoleCategory, fetchRolesCategory]);

  return {
    rolesCategory,
    loading: loading,
    error,
    refetch: fetchRolesCategory,
    handleDelete,
    createRoleCategory: handleCreateRoleCategory,
    updateRoleCategory,
  };
}; 